@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use 'sass:color' as sassColor;

$hover-shadow-primary: sassColor.adjust($color-primary-purple, $alpha: -0.8);
$hover-shadow-error: sassColor.adjust($color-primary-red, $alpha: -0.8);

.InputText {
  .Layout {
    @extend %form-control-border;
    @extend %form-control-background;

    display: flex;
    gap: 4px;
    align-items: center;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    overflow: hidden;

    .ClearBtn {
      display: none;

      button {
        display: flex;
        border-radius: 50%;
        align-items: center;
        background-color: $theme-color-sub-background;
        color: $theme-color-text;
        padding: 3px;
      }
    }

    &:hover {
      box-shadow: 0 0 0 3px $hover-shadow-primary;

      .ClearBtn {
        display: block;
      }
    }

    &:focus-within {
      border-color: $color-primary-purple;
      box-shadow: 0 0 0 3px $hover-shadow-primary;

      .ClearBtn {
        display: block;
      }
    }

    &.Readonly {
      background-color: $theme-color-input-readonly;
      color: $theme-color-readonly-field-text;
      border: 1px solid $theme-color-input-readonly-border;

      input::placeholder {
        color: $theme-placeholder-text;
      }

      &:hover,
      &:focus,
      &:focus-within {
        box-shadow: none;
      }
    }

    &.Disabled {
      @extend .Readonly;
    }

    &.Invalid {
      border-color: $color-primary-red;

      &:hover,
      &:focus-within {
        box-shadow: 0 0 0 3px $hover-shadow-error;
      }
    }
  }

  input {
    @extend %form-control-font;

    flex-grow: 1;
    border: none;
    outline: none;
    padding: 0;
    height: $component-height;
    box-sizing: border-box;
    appearance: none;
    width: 100%;
    background-color: transparent;

    &::placeholder {
      color: $theme-placeholder-text;
    }

    &[disabled] {
      color: $theme-color-readonly-field-text !important;
      cursor: not-allowed;
      pointer-events: none;
      color: $theme-color-sub-text;
      box-shadow: none;
    }

    &[readonly] {
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;
      color: $theme-color-readonly-field-text;
    }
  }

  .LeadingIcon {
    padding: 0 4px 0 0;
    display: inline-block;
    color: $theme-filter-icon-color;
  }

  .TrailingIcon {
    display: inline-block;
    color: $theme-filter-icon-color;
  }

  .ErrorMessage {
    @extend %form-control-invalid-font;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    padding: 8px 2px;
    font-size: $font-size-normal;
    // error message should be control by developer instead of system generate?
    // word-break: break-all;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}
